/**
 * 用于显示用户列表和客户列表或者room列表
 */
import React, {useState, useEffect, useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {List, Avatar, Spin, Tag, Divider, Skeleton} from 'antd';
import styles from './list.module.less';
import {getJson} from '@/util/ajaxUtils';
import ConversationContext from '@/page/conversation/ConPage/conversationContext';
import classNames from 'classnames';
import {members} from '@/api/room';
import dayjs from 'dayjs';
import InfiniteScroll from 'react-infinite-scroll-component';

const {Item} = List;
const {Meta} = Item;

function UserList({url, filterParams = {}, type = 0, receiveType = 2, newClass}) {
    const [loading, setLoading] = useState(false);
    const [records, setRecords] = useState([]);
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(0);
    const {from, setFrom, receive, setReceive, fromType} = useContext(ConversationContext);
    useEffect(() => {
        init();
        console.log(fromType);
    }, [filterParams.s, url]);

    function init(isInit = true) {
        // console.log(isInit, type);
        if (url == null || loading) {
            return;
        }
        setLoading(true);
        let realCurrent = isInit ? 1 : current;
        let paramsData = {
            ...filterParams,
            current: realCurrent,
        };

        // let realCurrent = isInit ? 1 : current;
        // let paramsData = {
        //     ...filterParams,
        //     current: realCurrent,
        // };
        // setRecords([]);
        // setLoading(true);
        getJson(url, {
            params: {...paramsData},
        }).then(({data}) => {
            if (!_.isEmpty(data) && type === 0) {
                let {current, total} = data;
                let tempData = isInit ? [] : [...records];
                // const finalData = tempData.concat(data.records);
                setCurrent(current + 1);
                setTotal(total);
                setRecords([...tempData, ...data.records]);
            }
            if (!_.isEmpty(data) && type === 1) {
                let temp = [];
                data.records.length > 0 &&
                    data.records.forEach(item => {
                        const {receiveCustomer, receiveUser, roomInfo} = item;
                        receiveType === 1 && temp.push(receiveCustomer);
                        receiveType === 2 && temp.push(receiveUser);
                        receiveType === 3 && temp.push(roomInfo);
                    });
                let tempData = isInit ? [] : [...records];
                // const finalData = tempData.concat(temp);
                setCurrent(data.current + 1);
                setTotal(data.total);
                setRecords([...tempData, ...temp]);
            }
            setLoading(false);
        });
    }

    function select(item) {
        if (type === 0) {
            setFrom(item);
            setReceive({});
        } else {
            /**
             * 如果是群，需要先查询出所有群成员
             */
            if (receiveType === 3) {
                members(item.chatId).then(res => {
                    item.memberList = res.data;
                    setReceive(item);
                });
            } else setReceive(item);
        }
    }

    function renderRoomAvatar(roomAvatar) {
        return (
            !_.isEmpty(roomAvatar) && (
                <div className={styles.roomAvatar}>
                    {roomAvatar.map((avatar, i) => (
                        <Avatar src={avatar} size={13} shape="square" key={i} />
                    ))}
                </div>
            )
        );
    }

    // function onLoadMore() {
    //     init(false);
    // }
    //
    // const loadMore =
    //     records.length > 0 && records.length < total ? (
    //         <div className={styles.loadMore}>
    //             <Button onClick={onLoadMore}>加载更多</Button>
    //         </div>
    //     ) : null;

    function loadMore() {
        init(false);
    }

    function renderReceiveName(item) {
        let {name, realName} = item;
        if (receiveType == 1 || fromType == 1) {
            return (
                <div>
                    <div>{name || '未命名'}</div>
                    <div>
                        <Tag color={realName ? '#2db7f5' : '#f50'}>{realName || '未实名'}</Tag>
                    </div>
                </div>
            );
        } else {
            return <div>{name || '未命名'}</div>;
        }
    }

    return (
        <div className={classNames(styles.container, !_.isEmpty(newClass) && newClass)}>
            <div
                id={'scrollableDiv_' + type}
                style={{
                    height: '80vh',
                    overflow: 'auto', // padding: '0 5px',
                    // border: '1px solid rgba(140, 140, 140, 0.35)',
                }}
            >
                <InfiniteScroll
                    dataLength={records.length}
                    next={loadMore}
                    hasMore={records.length < total}
                    endMessage={<Divider plain>已经加载全部</Divider>}
                    scrollableTarget={'scrollableDiv_' + type}
                    loader={
                        <Skeleton
                            avatar={{shape: 'square'}}
                            paragraph={{
                                rows: 0,
                            }}
                            active
                        />
                    }
                >
                    <Spin spinning={loading}>
                        <List
                            itemLayout="horizontal"
                            dataSource={records}
                            split={true}
                            locale={{emptyText: '暂无数据'}}
                            renderItem={(item, i) => (
                                <div style={{cursor: 'pointer'}}>
                                    <Meta
                                        onClick={() => select(item)}
                                        key={i}
                                        avatar={
                                            receiveType === 3 ? (
                                                <>{renderRoomAvatar(item.roomAvatar)}</>
                                            ) : (
                                                <Avatar
                                                    src={item.avatar}
                                                    className={styles.avatar}
                                                />
                                            )
                                        }
                                        title={
                                            <div
                                                className={classNames(styles.name, {
                                                    [styles.selected]:
                                                        (type === 0
                                                            ? from && from.id
                                                            : receive && receive.id) === item.id,
                                                })}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <div>{renderReceiveName(item)}</div>
                                                    <div>
                                                        {type === 1
                                                            ? item.msgTime
                                                                ? dayjs(
                                                                      parseInt(item.msgTime)
                                                                  ).format('YYYY-MM-DD HH:mm:ss')
                                                                : ''
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        description={
                                            type === 0
                                                ? item.email || <>&nbsp;</>
                                                : (item.speaker ? item.speaker + ':' : '') +
                                                  (item.speakContent ? item.speakContent : '')
                                        }
                                    />
                                    <Divider />
                                </div>
                            )}
                        />
                    </Spin>
                </InfiniteScroll>
            </div>
        </div>
    );
}

UserList.propTypes = {
    // 数据查询url
    url: PropTypes.string,
    type: PropTypes.number, // 类型0 发送人 1 接收人
    receiveType: PropTypes.number, // 收件人类型 1 客户 2 内部联系人 3 群聊
    filterParams: PropTypes.object,
    newClass: PropTypes.string,
};

export default UserList;
